import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'replyMentionsToCode' })
export class ReplyMentionsToCodePipe implements PipeTransform {
    transform(text): string {
        const wrapper = document.createElement('div');

        wrapper.innerHTML = text;

        const mentorsFromHtml = wrapper.getElementsByClassName('mention');
        Array.from(mentorsFromHtml).forEach((mentionElement) => {
            mentionElement.replaceWith('{User:' + mentionElement.getAttribute('data-mention-id') + '}');
        });

        return wrapper.innerHTML;
    }
}
